export const getDefaultApplication = () => {
  return {
    inputCompany: "",
    inputPosition: "",
    inputApplication: "",
    inputAddress: "",
    inputContact: "",
    inputPhone: "",
    inputSalary: "",
    inputApplied: "",
    inputResponse: "",
    inputDate: "",
  };
};
